var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _vm.task
        ? _c(
            "div",
            {
              staticClass:
                "d-flex flex-column flex-md-row align-items-md-center py-4",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "avatar-group avatar-group--cc-sm d-flex align-items-center",
                },
                [
                  _vm.getImage(_vm.task.assigned_by).hasImage
                    ? _c(
                        "a",
                        {
                          staticClass: "avatar avatar-xl rounded-circle",
                          attrs: { href: "#" },
                        },
                        [
                          _c("img", {
                            attrs: {
                              alt: "Image placeholder",
                              src: _vm.getImage(_vm.task.assigned_by).avatar,
                              "data-toggle": "tooltip",
                              title:
                                "This comment is viewable by: Suman Khatiwada",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  !_vm.getImage(_vm.task.assigned_by).hasImage
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "avatar avatar-xl avatar-name text-md text-white rounded-circle",
                          class: _vm.getImage(_vm.task.assigned_by).bg,
                          attrs: {
                            href: "#",
                            "data-toggle": "tooltip",
                            title:
                              "This comment is viewable by: Suman Khatiwada",
                            "data-target": "offcanvascced_int",
                            "data-offcanvasfrom": "offcanvas",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.getImage(_vm.task.assigned_by).avatar)
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "pl-3" }, [
                    _c("h1", { staticClass: "h2 text-black lh-110 mb-2" }, [
                      _vm._v(_vm._s(_vm.task.project.name)),
                    ]),
                    _c("span", { staticClass: "text-primary" }, [
                      _vm._v(_vm._s(_vm.task.name)),
                    ]),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "mt-sm-0 mt-4 ml-md-auto d-flex flex-column flex-sm-row align-items-sm-center",
                },
                [
                  _c("div", { staticClass: "progress-label mr-4" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "text-white text-capitalize p-0 mr-1 btn btn-link timesheet-icon",
                        attrs: {
                          "data-toggle": "tooltip",
                          "data-placement": "top",
                          title: "Timesheet Icon",
                          "data-target": "offcanvasTimer",
                          "data-offcanvasfrom": "offcanvas",
                        },
                        on: { click: _vm._onTimesheetEntryClicked },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "icon-shape__timer-info",
                            attrs: {
                              id: "Layer_1",
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 89.7 89.7",
                            },
                          },
                          [
                            _c("path", {
                              staticClass: "st0",
                              attrs: {
                                d: "M29.1 52.7v3.1c-1.9-.4-2.5-.8-2.5-1.6v-.1c0-.8.7-1.4 2.5-1.4zM34.9 64.9c0 .8-.7 1.3-2.4 1.4v-3c1.9.3 2.4.8 2.4 1.6z",
                              },
                            }),
                            _c("path", {
                              staticClass: "st0",
                              attrs: {
                                d: "M30.2 29.3C13.5 29.3 0 42.8 0 59.5s13.5 30.2 30.2 30.2 30.2-13.5 30.2-30.2-13.5-30.2-30.2-30.2zm12.1 34.9c0 4.9-3.8 7.7-9.6 8.2V76h-3.8v-3.6h-.1c-4.1-.3-8.1-1.7-11.2-3.8l3.8-5.6c2.7 1.8 5.3 2.7 7.7 3.1V63c-6.5-1.3-10-3.3-10-8.1v-.1c0-4.6 3.3-7.9 9.9-8.3v-2.1h3.8v2.2c3.4.3 6.2 1.4 8.7 3L38 55.2c-1.6-1.1-3.5-1.9-5.4-2.3v3c6.2 1.2 9.7 3.1 9.7 8.3zM54.8 32.3v-.4l1.1-16v-.2c.2-1.4 1.3-2.3 2.6-2.3 1.4 0 2.5 1.1 2.6 2.4l1 14.6c0 .4.2.9.5 1.2l6.5 7.7.1.1c.8 1.1.7 2.5-.2 3.5-1 1-2.5 1.1-3.6.1l-9-7.5c-.2-.1-.3-.3-.5-.4-.7-.7-1.1-1.7-1.1-2.8 0 .1 0 .1 0 0z",
                              },
                            }),
                            _c("path", {
                              staticClass: "st0",
                              attrs: {
                                d: "M59.5 0c-15.9 0-29 12.4-30.1 28h.7c2.6 0 5.1.3 7.5.9.7-11.5 10.2-20.6 21.9-20.6 12.1 0 21.9 9.8 21.9 21.9 0 11.7-9.1 21.2-20.6 21.9.6 2.4.9 4.9.9 7.5v.7c15.7-1.1 28-14.1 28-30.1C89.7 13.5 76.2 0 59.5 0z",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "gantt_side_content gantt_left",
                        on: { click: _vm._onTimesheetBudgetClicked },
                      },
                      [_vm._m(0)]
                    ),
                    _c(
                      "span",
                      { staticClass: "button__fixer" },
                      [
                        _c("flat-picker", {
                          staticClass:
                            "form-control-value bg-danger text-white text-capitalize px-2 w-px-100 u-p-context-menu text-center date",
                          attrs: { config: { wrap: true, allowInput: false } },
                          model: {
                            value: _vm.selectedDate,
                            callback: function ($$v) {
                              _vm.selectedDate = $$v
                            },
                            expression: "selectedDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger my-md-0 my-4",
                      attrs: {
                        type: "button",
                        "data-toggle": "tooltip",
                        "data-placement": "top",
                        title: "",
                        "data-original-title":
                          "This will close the Task and archive it for this project",
                      },
                    },
                    [_vm._v("Complete")]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-xl-12 comment-box" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column flex-md-row comment-header w-100 align-items-start align-items-md-center",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "comment-header__left d-flex flex-column flex-sm-row align-items-sm-center",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center mr-4 mb-3 mb-sm-0",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "comment-header__from-to" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex w-100 align-items-center",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "d-inline-flex mr-1" },
                                    [
                                      _vm.assignedByUser
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "avatar-group",
                                              attrs: {
                                                href: "javascript:void(0)",
                                                "data-target": "offcanvasFrom",
                                                "data-offcanvasfrom":
                                                  "offcanvas",
                                              },
                                              on: {
                                                click: _vm._onAssignedByClicked,
                                              },
                                            },
                                            [
                                              _vm.assignedByUser.image
                                                ? _c("img", {
                                                    staticClass:
                                                      "avatar avatar-xs avatar--34 rounded-circle",
                                                    attrs: {
                                                      src: _vm.assignedByUser
                                                        .image,
                                                      alt: "From",
                                                      "data-toggle": "tooltip",
                                                      "data-placement": "top",
                                                      title:
                                                        "Task From: " +
                                                        _vm.assignedByUser
                                                          .first_name +
                                                        " " +
                                                        _vm.assignedByUser
                                                          .last_name,
                                                    },
                                                  })
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "avatar avatar-xs avatar--34 rounded-circle",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          (
                                                            _vm.assignedByUser
                                                              .first_name ||
                                                            "NA"
                                                          )
                                                            .substring(0, 2)
                                                            .toUpperCase()
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._m(1),
                                  _c("div", { staticClass: "d-inline-flex" }, [
                                    _vm.assignedToUser
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "avatar-group",
                                            attrs: {
                                              href: "javascript:void(0)",
                                              "data-target": "offcanvasTo",
                                              "data-offcanvasfrom": "offcanvas",
                                            },
                                            on: {
                                              click: _vm._onAssignedToClicked,
                                            },
                                          },
                                          [
                                            _vm.assignedToUser.image
                                              ? _c("img", {
                                                  staticClass:
                                                    "avatar avatar-xs avatar--34 rounded-circle",
                                                  attrs: {
                                                    src: _vm.assignedToUser
                                                      .image,
                                                    alt: "From",
                                                    "data-toggle": "tooltip",
                                                    "data-placement": "top",
                                                    title:
                                                      "Task To: " +
                                                      _vm.assignedToUser
                                                        .first_name +
                                                      " " +
                                                      _vm.assignedToUser
                                                        .last_name,
                                                  },
                                                })
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "avatar avatar-xs avatar--34 rounded-circle",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        (
                                                          _vm.assignedToUser
                                                            .first_name || "NA"
                                                        )
                                                          .substring(0, 2)
                                                          .toUpperCase()
                                                      )
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "comment-header__cc pl-4" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "avatar-group avatar-group--cc-sm d-flex align-items-center appendCced appendCced-int",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "cced-1 avatar avatar-xs avatar--38 rounded-circle",
                                      attrs: {
                                        href: "javascript:void(0)",
                                        "data-toggle": "tooltip",
                                        "data-original-title":
                                          "This comment is viewable by: Ryan Tompson",
                                        "data-target": "offcanvascced_int",
                                        "data-offcanvasfrom": "offcanvas",
                                      },
                                      on: { click: _vm._onCCClicked },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          alt: "Image placeholder",
                                          src: require("../../assets/img/theme/team-4.jpg"),
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "cced-2 avatar avatar-xs avatar--38 rounded-circle",
                                      attrs: {
                                        href: "javascript:void(0)",
                                        "data-toggle": "tooltip",
                                        "data-original-title":
                                          "This comment is viewable by: Ryan Tompson",
                                        "data-target": "offcanvascced_int",
                                        "data-offcanvasfrom": "offcanvas",
                                      },
                                      on: { click: _vm._onCCClicked },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          alt: "Image placeholder",
                                          src: require("../../assets/img/theme/team-2.jpg"),
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _vm._m(2),
                        _c(
                          "div",
                          { staticClass: "comment-header__cc__ext pl-2 ml-1" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "avatar-group avatar-group--cc-sm d-flex align-items-center appendCced appendCced-ext",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "cced-1 avatar avatar-xs avatar--38 rounded-circle",
                                    attrs: {
                                      href: "javascript:void(0)",
                                      "data-toggle": "tooltip",
                                      "data-original-title":
                                        "This comment is viewable by: Ryan Tompson",
                                      "data-target": "offcanvascced_ext",
                                      "data-offcanvasfrom": "offcanvas",
                                    },
                                    on: { click: _vm._onCSUClicked },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "grayscale",
                                      attrs: {
                                        alt: "Image placeholder",
                                        src: require("../../assets/img/theme/team-4.jpg"),
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "cced-2 avatar avatar-xs avatar--38 rounded-circle",
                                    attrs: {
                                      href: "javascript:void()",
                                      "data-toggle": "tooltip",
                                      "data-original-title":
                                        "This comment is viewable by: Ryan Tompson",
                                      "data-target": "offcanvascced_ext",
                                      "data-offcanvasfrom": "offcanvas",
                                    },
                                    on: { click: _vm._onCSUClicked },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "grayscale",
                                      attrs: {
                                        alt: "Image placeholder",
                                        src: require("../../assets/img/theme/team-2.jpg"),
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
            _c("div", { staticClass: "card-body" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column flex-sm-row align-items-sm-center",
                },
                [
                  _c("div", { staticClass: "w-100" }, [
                    _c("div", { staticClass: "row align-items-center" }, [
                      _c("div", { staticClass: "col-auto pr-0" }, [
                        _c("span", { staticClass: "avatar-group" }, [
                          _c(
                            "a",
                            {
                              staticClass: "d-inline-flex",
                              attrs: { href: "javascript:void(0)" },
                              on: { click: _vm._onUploadClicked },
                            },
                            [
                              _c("img", {
                                staticClass: "avatar-md",
                                attrs: {
                                  src: require("../../assets/img/theme/icon-camera.png"),
                                  alt: "Upload File",
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "col" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.comment,
                              expression: "comment",
                            },
                          ],
                          staticClass:
                            "form-control borderRadius-25 textarea__tweak",
                          attrs: { rows: _vm.numLines },
                          domProps: { value: _vm.comment },
                          on: {
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              if (
                                $event.ctrlKey ||
                                $event.shiftKey ||
                                $event.altKey ||
                                $event.metaKey
                              )
                                return null
                              return _vm._onSubmitClicked($event)
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.comment = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success ml-sm-3 mt-sm-0 mt-3",
                      attrs: { type: "button" },
                      on: { click: _vm._onSubmitClicked },
                    },
                    [_vm._v("Submit")]
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c(
                    "vue-clip",
                    {
                      attrs: {
                        options: _vm.dropzoneOptions,
                        "on-removed-file": _vm._onFileRemoved,
                        "on-complete": _vm._onComplete,
                        "on-added-file": _vm._onFileAdded,
                      },
                    },
                    [
                      _c("template", { slot: "clip-uploader-action" }, [
                        _c("div", [
                          _c("div", { staticClass: "dz-message" }, [
                            _c("h5", [
                              _vm._v(
                                "Click or Drag and Drop files here upload"
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("template", { slot: "clip-uploader-body" }, [
                        _c(
                          "div",
                          { staticClass: "tf__attachment-box" },
                          [
                            _vm._l(_vm.attachments, function (file, ind) {
                              return _c(
                                "div",
                                { key: ind, staticClass: "tf__content-box" },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "tf__c-b--close",
                                      attrs: { href: "#" },
                                    },
                                    [_c("i", { staticClass: "fas fa-times" })]
                                  ),
                                  file.content_type.includes("image")
                                    ? _c("div", { staticClass: "image" }, [
                                        _c("img", {
                                          attrs: { src: file.file_url },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "tf__c-b--filename" },
                                          [_vm._v(_vm._s(file.user_file_name))]
                                        ),
                                      ])
                                    : _c("div", { staticClass: "file" }, [
                                        _c(
                                          "div",
                                          { staticClass: "tf__c-b--file" },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: require("@/assets/img/icons/svgs/solid/arrowLeft.svg"),
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "tf__c-b--filename" },
                                          [_vm._v(_vm._s(file.user_file_name))]
                                        ),
                                      ]),
                                ]
                              )
                            }),
                            _vm.uploading
                              ? _c("div", { staticClass: "tf__content-box" }, [
                                  _c("div", { staticClass: "loading" }, [
                                    _c("i", {
                                      staticClass: "fas fa-spinner fa-pulse",
                                    }),
                                  ]),
                                ])
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "card" }, [
            _vm.task
              ? _c(
                  "div",
                  { staticClass: "card-body card-body--3 p-0" },
                  _vm._l(_vm.task.comments, function (cmt, ind) {
                    return _c(
                      "div",
                      {
                        key: ind,
                        staticClass:
                          "list-group list-group-flush flex-column-reverse",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "list-group-item list-group-item-action flex-column align-items-start py-4 px-4",
                          },
                          [
                            _vm._m(3, true),
                            _c("div", {
                              staticClass: "comment-description mt-4",
                              domProps: { innerHTML: _vm._s(cmt.comment) },
                            }),
                            _c("br"),
                            _c(
                              "div",
                              { staticClass: "tf__attachment-box" },
                              _vm._l(cmt.attachments, function (file, ind) {
                                return _c(
                                  "div",
                                  { key: ind, staticClass: "tf__content-box" },
                                  [
                                    file.content_type.includes("image")
                                      ? _c("div", { staticClass: "image" }, [
                                          _c("img", {
                                            attrs: { src: file.file_url },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "tf__c-b--filename",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(file.user_file_name)
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _c("div", { staticClass: "file" }, [
                                          _vm._m(4, true),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "tf__c-b--filename",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(file.user_file_name)
                                              ),
                                            ]
                                          ),
                                        ]),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._m(5),
      _c(
        "SidebarRight",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.outside,
              expression: "outside",
            },
          ],
          class: [
            "navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--400",
            { open: _vm.showSideBar },
          ],
          on: { overlayClicked: _vm.outside },
        },
        [
          _c(_vm.currentView, {
            tag: "component",
            attrs: {
              sidebarMode: _vm.sidebarMode,
              sideBarUsers: _vm.sideBarUsers,
              sideBarUser: _vm.sideBarUser,
            },
            on: { userSelected: _vm._onUserSelected },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "btn-group btn-group--totalhours",
        attrs: { role: "group", "aria-label": "Basic example" },
      },
      [
        _c("button", { staticClass: "btn btn-info px-0" }, [
          _c(
            "span",
            {
              staticClass: "bg-dar text-white text-capitalize u-p-cursor px-2",
              attrs: {
                "data-toggle": "tooltip",
                "data-placement": "top",
                title: "5 out of 10 hours quoted on this Task",
                "data-target": "offcanvasTimer",
                "data-offcanvasfrom": "offcanvas",
              },
            },
            [_vm._v("5/10")]
          ),
        ]),
        _c("button", { staticClass: "btn btn-default px-1" }, [
          _c(
            "span",
            {
              staticClass: "px-0",
              attrs: {
                "data-toggle": "tooltip",
                "data-placement": "top",
                title: "Project is 15 hours over quote",
                "data-target": "offcanvasTimer",
                "data-offcanvasfrom": "offcanvas",
              },
            },
            [_vm._v("120/105")]
          ),
          _c(
            "span",
            {
              staticClass: "badge-secondary ml-1",
              attrs: {
                "data-toggle": "tooltip",
                "data-placement": "top",
                title: "17 hours ($170) per hour = $17,000",
                "data-target": "offcanvasTimer",
                "data-offcanvasfrom": "offcanvas",
              },
            },
            [_vm._v("$ 1.7k")]
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-inline-flex mr-1" }, [
      _c("i", { staticClass: "fas fa-arrow-right text-xs" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "label",
      { staticClass: "comment-header__switch custom-toggle" },
      [
        _c("input", {
          staticClass: "custom-control-input switch-btn",
          attrs: {
            type: "checkbox",
            id: "grayscale",
            value: "grayscale",
            name: "grayscale_switch",
          },
        }),
        _c("span", {
          staticClass: "custom-toggle-slider rounded-circle",
          attrs: {
            id: "showRadio",
            "data-label-off": "OFF",
            "data-label-on": "ON",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "d-flex flex-column flex-md-row comment-header w-100 align-items-md-center",
      },
      [
        _c("div", { staticClass: "comment-header__left" }, [
          _c("div", { staticClass: "d-flex" }, [
            _c(
              "div",
              { staticClass: "comment-header__from-to align-items-center" },
              [
                _c("div", { staticClass: "d-flex w-100 align-items-center" }, [
                  _c("div", { staticClass: "d-inline-flex mr-1" }, [
                    _c(
                      "a",
                      {
                        staticClass: "avatar-group",
                        attrs: {
                          href: "javascript:void(0)",
                          "data-target": "offcanvasFrom",
                          "data-offcanvasfrom": "offcanvas",
                        },
                      },
                      [
                        _c("img", {
                          staticClass:
                            "avatar avatar-xs avatar--34 rounded-circle",
                          attrs: {
                            src: require("../../assets/img/theme/team-1.jpg"),
                            alt: "From",
                            "data-toggle": "tooltip",
                            "data-placement": "top",
                            title: "",
                            "data-original-title": "Task From: Gabriel Garcia",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "d-inline-flex mr-1" }, [
                    _c("i", { staticClass: "fas fa-arrow-right text-xs" }),
                  ]),
                  _c("div", { staticClass: "d-inline-flex" }, [
                    _c(
                      "a",
                      {
                        staticClass: "avatar-group",
                        attrs: {
                          href: "javascript:void(0)",
                          "data-target": "offcanvasTo",
                          "data-offcanvasfrom": "offcanvas",
                        },
                      },
                      [
                        _c("img", {
                          staticClass:
                            "avatar avatar-xs avatar--34 rounded-circle",
                          attrs: {
                            src: require("../../assets/img/theme/team-1.jpg"),
                            alt: "To",
                            "data-toggle": "tooltip",
                            "data-placement": "top",
                            title: "",
                            "data-original-title": "Task To: Suman Khatiwada",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "comment-header__cc align-self-center pl-4" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "avatar-group avatar-group--cc-sm d-flex align-items-center",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass:
                          "avatar avatar-xs avatar--38 rounded-circle",
                        attrs: {
                          href: "#",
                          "data-toggle": "tooltip",
                          "data-original-title":
                            "This comment is viewable by: Ryan Tompson",
                          "data-target": "offcanvascced",
                          "data-offcanvasfrom": "offcanvas",
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            alt: "Image placeholder",
                            src: require("../../assets/img/theme/team-1.jpg"),
                          },
                        }),
                      ]
                    ),
                    _c(
                      "a",
                      {
                        staticClass:
                          "avatar avatar-xs avatar--38 rounded-circle",
                        attrs: {
                          href: "#",
                          "data-toggle": "tooltip",
                          "data-original-title":
                            "This comment is viewable by: Romina Hadid",
                          "data-target": "offcanvascced",
                          "data-offcanvasfrom": "offcanvas",
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            alt: "Image placeholder",
                            src: require("../../assets/img/theme/team-2.jpg"),
                          },
                        }),
                      ]
                    ),
                    _c(
                      "a",
                      {
                        staticClass:
                          "avatar avatar-xs avatar--38 rounded-circle",
                        attrs: {
                          href: "#",
                          "data-toggle": "tooltip",
                          "data-original-title":
                            "This comment is viewable by: Alexander Smith",
                          "data-target": "offcanvascced",
                          "data-offcanvasfrom": "offcanvas",
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            alt: "Image placeholder",
                            src: require("../../assets/img/theme/team-3.jpg"),
                          },
                        }),
                      ]
                    ),
                    _c(
                      "a",
                      {
                        staticClass:
                          "avatar avatar-xs avatar--38 avatar-name bg-success text-md text-white rounded-circle",
                        attrs: {
                          href: "#",
                          "data-toggle": "tooltip",
                          "data-original-title":
                            "This comment is viewable by: Suman Khatiwada",
                          "data-target": "offcanvascced",
                          "data-offcanvasfrom": "offcanvas",
                        },
                      },
                      [_vm._v("SK")]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "comment-header__right mt-2 mt-md-0 ml-md-auto" },
          [
            _c("div", { staticClass: "progress-label row" }, [
              _c("small", { staticClass: "col-auto mr--2" }, [
                _vm._v("2 hrs ago"),
              ]),
              _c("div", { staticClass: "col-auto d-flex" }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "bg-danger text-white text-capitalize px-2 mr-1",
                    attrs: {
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      title: "",
                      "data-original-title":
                        "12 out of 10 hours quoted on this Task",
                    },
                  },
                  [_vm._v("12/10")]
                ),
                _c(
                  "span",
                  {
                    staticClass: "bg-dark text-white text-capitalize px-2 mr-1",
                    attrs: {
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      title: "",
                      "data-original-title": "Comment Number 4",
                    },
                  },
                  [_vm._v("4")]
                ),
                _c(
                  "span",
                  {
                    staticClass: "bg-danger text-white text-capitalize px-2",
                    attrs: {
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      title: "",
                      "data-original-title": "Due Date",
                    },
                  },
                  [_vm._v("20th January 2019")]
                ),
              ]),
            ]),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tf__c-b--file" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/icons/svgs/solid/arrowLeft.svg") },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("footer", { staticClass: "footer pt-0" }, [
      _c(
        "div",
        { staticClass: "row align-items-center justify-content-lg-between" },
        [
          _c("div", { staticClass: "col" }, [
            _c(
              "div",
              { staticClass: "copyright text-center text-lg-left text-muted" },
              [
                _vm._v("\n          © 2019\n          "),
                _c(
                  "a",
                  {
                    staticClass: "font-weight-bold ml-1",
                    attrs: {
                      href: "https://www.creative-tim.com",
                      target: "_blank",
                    },
                  },
                  [_vm._v("TaskForm")]
                ),
              ]
            ),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }